import './ConversationLogsModalVariablesDetails.css'
import ConversationLogVariable from './ConversationLogVariable/ConversationLogVariable';
const ConversationLogsModalVariablesDetails = ({ data }) => {


    const variablesJSON = JSON.parse(data.logs) ? (JSON.parse(data.logs).variables ?? []) : []

    let variables = Object.keys(variablesJSON).map((key) => [key, variablesJSON[key]]);
    variables = variables.sort((a, b) => a[0].localeCompare(b[0]));


    return (
        <div className="grid_container_conversation_variables_fields">
            {
                variables.map((variable, i) =>
                    <ConversationLogVariable key={i} variable={variable} />
                )
            }
        </div>
    );
};

export default ConversationLogsModalVariablesDetails;